<template>
    <div class="vx-breadcrumb" :class="$attrs.class">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
            </li>
            <li v-for="(link, index) in middleLinks" :key="index" class="inline-flex items-center">
                <router-link :to="link.url" v-if="link.url">{{ translateTitle(link.title) }}</router-link>
                <span class="text-primary cursor-default" v-else>{{ translateTitle(link.title) }}</span>
                <span class="breadcrumb-separator mx-2 flex items-start"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex">
                <span v-if="lastLink && lastLink.active" class="cursor-default">{{ translateTitle(lastLink.title) }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default{
  name: 'vx-breadcrumb',
  props: {
    route: {
      type: Object,
      required: true
    },
    isRTL: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    middleLinks() {
      return this.route.meta.breadcrumb ? this.route.meta.breadcrumb.slice(1, -1) : []
    },
    lastLink() {
      return this.route.meta.breadcrumb ? this.route.meta.breadcrumb.slice(-1)[0] : null
    }
  },
  methods: {
    translateTitle(title) {
      if (!title) return ''
      const key = `pageTitle.${title.toLowerCase().replace(/[\s-]+/g, '')}`
      if (this.$te(key)) {
        return this.$t(key)
      }
      return title
    }
  }
}
</script>
